import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import * as ReactDOM from 'react-dom';
import { Container, Content, CloseButton } from './modalContainer.styles';
import { accessibleClickHandler } from '../../../utils/accessibility';

ReactModal.setAppElement('#app');

const modalStyles = {
  overlay: {
    zIndex: 999,
    backgroundColor: 'rgba(0,0,0,0.67)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  content: {
    boxShadow: '0 2px 20px rgba(0,0,0,0.25)',
    background: 'black',
  },
};

export class ModalContainer extends PureComponent {
  static propTypes = {
    children: PropTypes.any,
    isOpen: PropTypes.bool,
    title: PropTypes.string,
    onClose: PropTypes.func,
    withCloseButton: PropTypes.bool,
  };

  static defaultProps = {
    withCloseButton: true,
  };

  close = () => {
    this.props.onClose();
  };

  render() {
    const { children, isOpen, title, withCloseButton, ...modalProps } = this.props;

    return ReactDOM.createPortal(
      <Container
        isOpen={isOpen}
        onRequestClose={this.close}
        contentLabel={title}
        style={modalStyles}
        {...modalProps}
      >
        <Content>
          {children}

          {withCloseButton && (
            <CloseButton {...accessibleClickHandler(this.close)}>close</CloseButton>
          )}
        </Content>
      </Container>,
      document.body,
    );
  }
}
